function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M166.9 182.8l13.4 4.5 7.9-23.4-7.1-21.3 6.3-18.9-13.4-4.5-7.8 23.4 7 21.3-6.3 18.9zm-28.4-63.6l-7.8 23.4 7.1 21.3-6.3 18.9 13.4 4.5 7.8-23.4-7-21.3 6.3-18.9-13.5-4.5zm-21.9 4.5l-13.5-4.5-7.8 23.4 7.1 21.3-6.4 18.9 13.5 4.5 7.8-23.4-7.1-21.3 6.4-18.9zm166.9-.7L141.7 48.4 0 123l13.2 25.2 14.8-7.8v93.5h227.5v-93.5l14.7 7.7 13.3-25.1zm-56.4 82.4H56.4v-80l85.3-44.9 85.3 44.9.1 80z"
})));